var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",attrs:{"id":"app"}},[_c('jje-background'),_c('div',{staticClass:"content-wrapper"},[_c('jje-header'),_c('router-view'),_c('jje-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }